<template>
<div id="xinxi" class="xinxi">
	<UserComponent :getMyUserRelation="get_my_user_relation" :uinfoBtn="false" :xuejiInfoDisplay="hideType === 3" v-if="user_component_display"></UserComponent>
    <!-- <div class="line wx_bind" v-if="wx_name">
		<div class="leftCon">
			<i class="iconfont">&#xe607;</i>
			<h2>微信绑定</h2>
			<span class="wx_name">{{wx_name}}</span>
		</div>
		<div class="rightCon">
			<p class="remove_bind" @click="remove_bind">解除绑定</p>
		</div>
    </div> -->
	<!-- <div @click="open_attestation" class="line pwdChange" v-if="ruleForm.is_certified==1&&temp.attestation">
		<div class="leftCon">
			<i class="iconfont">&#xec4d;</i>
			<h2>实名认证</h2>
		</div>
        <i class="iconfont rightIcon">&#xe610;</i>
		<span class="text_data" v-if="ruleForm.certified">{{'当前实名'+encryption(ruleForm.idcard)}}</span>
    </div> -->
    <!-- <div @click="dialogFormVisible = true" class="line pwdChange">
		<div class="leftCon">
			<i class="iconfont">&#xe609;</i>
			<h2>修改密码</h2>
		</div>
        <i class="iconfont rightIcon">&#xe610;</i>
    </div> -->
    <!-- <div @click="jump_purchased" class="line purchased" v-if="temp.purchased">
		<div class="leftCon">
			<i class="iconfont">&#xe677;</i>
			<h2>已购课程</h2>
		</div>
        <i class="iconfont rightIcon">&#xe610;</i>
    </div> -->
    <!-- <div @click="jump_logs" class="line logs">
		<div class="leftCon">
			<i class="iconfont">&#xe678;</i>
			<h2>操作日志</h2>
		</div>
        <i class="iconfont rightIcon">&#xe610;</i>
    </div> -->
</div>
</template>

<script>
import UserComponent from './user_component.vue'
function xuejiTxt(ji){
	switch (ji){
		case 1:
			return "在读"
		case 2:
			return "毕业"
		case 3:
			return "停学"
		case 4:
			return "退学"
	}
}
export default {
	name: 'index'
	,props:["userIndex"]
	,data () {
		// var checkAge = (rule, value, callback) => {
		// 	if (!value) {
		// 		return callback(new Error('年龄不能为空'));
		// 	}
		// 	setTimeout(() => {
		// 		if (!Number.isInteger(value)) {
		// 			callback(new Error('请输入数字值'));
		// 		} else {
		// 			if (value < 18) {
		// 				callback(new Error('必须年满18岁'));
		// 			} else {
		// 				callback();
		// 			}
		// 		}
		// 	}, 1000);
		// };
		var validatePass = (rule, value, callback) => {
			// console.log(value);
			let pwdReg = new RegExp('(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8}');
			if (value === '' || value === undefined) {
				callback(new Error('请输入密码'));
			} else if (!pwdReg.test(value)) {
				callback(new Error('密码至少包含字母、数字、特殊字符各1位,总长度8位及以上!'));
			} else {
				if (this.ruleForm.checkPass !== '') {
					this.$refs.ruleForm.validateField('checkPass');
				}
				callback();
			}
		};
		var validatePass2 = (rule, value, callback) => {
			// console.log(value);
			if (value === '' || value === undefined) {
				callback(new Error('请再次输入密码'));
			} else if (value !== this.ruleForm.pass) {
				callback(new Error('两次输入密码不一致!'));
			} else {
				callback();
			}
		};
		return {
      		temp: this.temp.userCenter.index,
			ruleForm: {
				profile:{},
				grade:{},
				major:{},
				market:{},
				mould:{},
				school:{},
				org:{},
				uname: '',
				uphone: '',
				area: '',
				email: '',
				school: '',
				grade: '',
				cengci: '',
				zhuanye: '',
				idcard:'',
				idcardInput:'',
				pass:'',
				checkPass:'',
				certified:false, //是否已经实名认证
				is_certified:2, //是否开启实名认证
			},
			wx_name:'',
			pwdRules:{
				//required：是否必填，message错误提示内容，trigger触发方式
				idcardInput: [
					{ required: true, message: '请输入身份证号', trigger: 'blur' },
				],
				pass: [
					// { required: true, message: '请输入新密码', trigger: 'blur' },
					{ validator: validatePass, required: true, trigger: 'blur' },
				],
				checkPass: [
					// { required: true, message: '请再次输入密码', trigger: 'blur' },
            		{ validator: validatePass2, required: true, trigger: 'blur' },
				],
			},
			user_component_display:false,	//信息显示
			dialogFormVisible: false,
			formLabelWidth: '120px',
		}
	}
	,components:{
		UserComponent,
	}
	,mounted:function(){
		var that = this
		this.$selfjs.getUserCallFn(this, function(res){
			let idcard = res.idcard,
				idcardType = '身份证'
			// that.ruleForm.uname=res.nick_name					//学生姓名
			// that.ruleForm.sex=that.$selfjs.getSex(idcard)	//性别
			// that.ruleForm.birthDate=that.$selfjs.getBirth(idcard)	//出生日期
			// that.ruleForm.uphone=res.mobile						//手机号码
			// that.ruleForm.xueli=res.max_education				//最高学历
			// that.ruleForm.area=res.student_from					//校区
			that.ruleForm.idcard=idcard						//证件号码
			that.wx_name=res.wx_name						//微信昵称
			that.unionid=res.unionid						//微信unionid
			if(idcard.length <= 15){
				idcardType = '其他'
			}
			// that.ruleForm.idcardType = idcardType					//证件类型
			// that.ruleForm.mianmao=res.polit_face				//政治面貌
			// that.ruleForm.minzu=res.nation						//民族
			// // that.ruleForm.email=res.email
			// that.ruleForm.school=res.school.school_name			//报考学校
			// that.ruleForm.nian=res.grade.grade_name				//年级
			// that.ruleForm.cengci=that.$store.state.const.major_level.find(v=>{ return v.id == res.major.major_level}).value		//学历层次
			// that.ruleForm.zhuanye=res.major.major_name			//报考专业
			// that.ruleForm.banji=res.grade.grade_name			//班级
			// that.ruleForm.xuehao=res.student_sn					//学号
			// that.ruleForm.xuezhi=res.student_system				//学制
			// that.ruleForm.xuejiSt=xuejiTxt(res.student_status)			//学籍状态
			that.ruleForm.yidong=res.yidong || "未申请"	//异动审核状态
			that.ruleForm.certified = res.certified
			that.ruleForm.is_certified = res.school.is_certified
			that.user_component_display = true
			// that.$store.dispatch('get_const').then((res)=>{
			// 	that.get_my_user_relation()
			// })
			
		})
	}
	,methods:{
		// 已购课程跳转
		jump_purchased(){
			this.$emit('jump',['/web/purchased/', 'purchased'])
		},
		// 操作日志跳转
		jump_logs(){
			this.$emit('jump',['/web/logs', 'logs'])
		},
		//实名认证跳转
		open_attestation(){
			// if (!this.ruleForm.certified) {
				this.$emit('jump',['/web/name_attestation/', 'name_attestation'])
			// }
		},
		//身份证脱敏
		encryption(text){
			if (text) {
				return text.replace(/(.{3}).*(.{3})/,"$1******$2")
			}
			
		},
		//获取我的详情
		get_my_user_relation(){
			return new Promise((resolve, reject) => {
				this.$ajax.get(
					this.global.serverSrc + this.global.qianzui + '/user_relation/my'
				)
				.then((res)=>{
        		    let resData = res.data
					if(resData.code==0){
						this.ruleForm.idcardType = '身份证'
						this.ruleForm = Object.assign(this.ruleForm ,resData.data)
						if(this.ruleForm.profile.idcard.length <= 15){
							this.ruleForm.idcardType = '其他'
						}
						this.ruleForm.cengci=this.$store.state.const.major_level.find(v=>{ return v.id == this.ruleForm.major.major_level}).value
						this.ruleForm.xuejiSt=xuejiTxt(this.ruleForm.student_status)
						this.ruleForm.sex = '保密'
						if (this.ruleForm.profile.gender!=0) {
							this.ruleForm.sex = this.ruleForm.profile.gender==1?'男':'女'
						}
						// this.ruleForm.sex=this.$selfjs.getSex(this.ruleForm)
						this.ruleForm.is_overseas_chinese_text = this.ruleForm.profile.is_overseas_chinese==1?'是':'否'
						this.ruleForm.is_disability_text = this.ruleForm.profile.is_disability==1?'是':'否'
						this.ruleForm.is_gangaotai_text = this.ruleForm.profile.is_gangaotai==1?'是':'否'
						// console.log(resData.data);
						if (!this.ruleForm.org) {
							this.ruleForm.org = {}
						}
						resolve(this.ruleForm)
						// this.get_majors()
						// this.get_user_relation_files()
						// console.log(this.ruleForm);


        		        // this.select_number = resData.data.max_select_course_count
        		    } 
				})
			})
			
		},
	}
	,computed:{
		//根据身份隐藏内容
		hideType(){
			return parseInt(this.$store.state.hideType)
		},
	}
}
</script>
<!-- scoped单页面有效属性 -->

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/userCenter/index.vue